
import './Header.css';

export default function Header()
{
    return (
        <header className='Header'>

                <div className='titre'>SANS FILTRE</div>

        </header>
    )
}

